import { Col, Row } from 'antd';
import React from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import StayTunedComponent from '../../CommonComponents/StayTunedComponent';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import useLocalization from '../../../Localization';

const OtherPartnersComponent = () => {
  const { ApplicationString } = useLocalization();
  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={ApplicationString['otherPartnersComponent.title']}
            subTitle={ApplicationString['pbss.generalInformation.subtitle']}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <StayTunedComponent />
          </SectionLayout>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default OtherPartnersComponent;
